export const PRICE = '23 USD'

export const BRAND = 'Nail Educator Ready™'

/** Hero carousel — original PDF pages, in the required order. */
export const insidePages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/n1qru3g58VaBWC5eq1VVKU/01_reflexiones_superficie_pag34.webp',
    caption: 'Seite 34',
    label: 'Unebene Oberfläche – Wellen, Dellen & Reflexionslinien',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/bHmvRvmJs6sQzWYCuy9SWy/02_tipos_de_fresas_pag4.webp',
    caption: 'Seite 4',
    label: 'Fräserfamilien im Überblick',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/6LSBwJGp8fv1fzYUJa9FpE/03_arquitectura_apex_pag24.webp',
    caption: 'Seite 24',
    label: 'Apex – Position & Fehler im Profil',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/pPYjSLt65RRwTfxS6xkZdr/04_errores_de_gel_pag36.webp',
    caption: 'Seite 36',
    label: 'Gel-Troubleshooting – sechs Fehlerbilder',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/2CK86mpTncADu1go1hXvRK/05_reparacion_paso_a_paso_pag39.webp',
    caption: 'Seite 39',
    label: 'Crack Repair – 6-Schritte-Protokoll',
  },
]

/** Pain points. */
export const painPoints = [
  {
    title: 'Stundenlange Vorbereitung',
    text: 'Du verbringst viel Zeit damit, Themen zu ordnen und Materialien für deine Schulungen zusammenzustellen.',
  },
  {
    title: 'Ständig neue Beispiele suchen',
    text: 'Du brauchst verständliche Bilder und Demonstrationen, um technische Abläufe anschaulich zu erklären.',
  },
  {
    title: 'Fehlende Unterrichtsstruktur',
    text: 'Du weißt, was du vermitteln möchtest – aber die sinnvolle Reihenfolge und Aufbereitung kosten Zeit.',
  },
  {
    title: 'Schwierige Fehlerkorrektur',
    text: 'Du möchtest Teilnehmerinnen nicht nur sagen, dass etwas falsch ist, sondern auch zeigen, warum und wie es besser geht.',
  },
]

/** Solution benefits. */
export const solutionBenefits = [
  {
    title: 'Klar aufgebaut',
    text: 'Fachthemen von den Grundlagen bis zu fortgeschrittenen Techniken.',
  },
  {
    title: 'Anschaulich erklärt',
    text: 'Bilder, Vergleiche, technische Darstellungen und praxisnahe Beispiele.',
  },
  {
    title: 'Für Trainerinnen gedacht',
    text: 'Übungen, Checklisten und Bewertungskriterien zur Unterstützung deiner Schulungen.',
  },
]

/** The six volumes. Accent colors match the covers in the mockup. */
export const volumes = [
  {
    number: 1,
    title: 'Nagelwissenschaft, Sicherheit & professionelle Grundlagen',
    description: 'Nagelanatomie, Produktwissen, Hygiene, Sicherheit und fachliche Grundlagen verständlich vermitteln.',
    accent: '#F6EADF',
  },
  {
    number: 2,
    title: 'Naturnagel & professionelle Maniküre',
    description: 'Vorbereitung, Nagelformen, Maniküretechniken und saubere Arbeitsabläufe systematisch erklären.',
    accent: '#F6D3C6',
  },
  {
    number: 3,
    title: 'Gelsysteme & strukturierte Maniküre',
    description: 'Geltechniken, Produktanwendung, Nagelaufbau und typische Fehler visuell vermitteln.',
    accent: '#E6D6F1',
  },
  {
    number: 4,
    title: 'Acryl, Verlängerungen & Nagelarchitektur',
    description: 'Verlängerungstechniken, Aufbau, Statik und professionelle Nagelarchitektur Schritt für Schritt behandeln.',
    accent: '#D6DCF4',
  },
  {
    number: 5,
    title: 'Fortgeschrittene Nageltechniken, Fräsertechnik & Fehleranalyse',
    description: 'Technikfehler erkennen, Ursachen verstehen und Korrekturen anhand anschaulicher Beispiele erklären.',
    accent: '#DDCBF0',
  },
  {
    number: 6,
    title: 'Unterricht, Bewertung & Schulungsorganisation',
    description:
      'Unterricht planen, praktische Übungen strukturieren und Leistungen anhand nachvollziehbarer Kriterien bewerten.',
    accent: '#F5E0C4',
  },
]

/** Before and after. */
export const beforeItems = [
  'Unterrichtsthemen einzeln zusammentragen.',
  'Passende Bildbeispiele suchen.',
  'Übungen von Grund auf entwickeln.',
  'Bewertungskriterien selbst formulieren.',
  'Immer wieder neue Unterlagen organisieren.',
]

export const afterItems = [
  'Auf sechs thematisch geordnete Fachbände zugreifen.',
  'Visuelle Erklärungen und Beispiele nutzen.',
  'Praktische Übungen als Grundlage verwenden.',
  'Checklisten und Bewertungsraster einbeziehen.',
  'Eigene Schulungen strukturierter vorbereiten.',
]

/** Who it is for. */
export const audience = [
  {
    title: 'Erfahrene Nageldesignerinnen',
    text: 'Du beherrschst die Techniken und möchtest deine ersten eigenen Schulungen planen.',
  },
  {
    title: 'Aktive Nageldesign-Trainerinnen',
    text: 'Du unterrichtest bereits und suchst zusätzliche visuelle und didaktische Materialien.',
  },
  {
    title: 'Betreiberinnen von Nageldesign-Akademien',
    text: 'Du möchtest deine Kursplanung mit strukturierten Fachinhalten und Bewertungshilfen unterstützen.',
  },
]

/** What the purchase includes. */
export const offerIncludes = [
  'Sechs thematisch aufgebaute Fachbände',
  'Visuelle Anleitungen und Fachbeispiele',
  'Übungen und Fehleranalysen',
  'Checklisten und Bewertungshilfen',
  'Inhalte für die strukturierte Unterrichtsplanung',
]

export const faqs = [
  {
    question: 'Was ist NAIL EDUCATOR READY™?',
    answer:
      'Eine digitale Sammlung aus sechs Fachbänden rund um Nageldesign-Techniken, Fehleranalyse und Unterrichtsgestaltung.',
  },
  {
    question: 'Für wen ist die Sammlung gedacht?',
    answer:
      'Für erfahrene Nageldesignerinnen, angehende Trainerinnen, aktive Ausbilderinnen und Betreiberinnen von Nageldesign-Akademien.',
  },
  {
    question: 'Ist das Produkt auf Deutsch?',
    answer: 'Ja. Es handelt sich um die deutsche Ausgabe von NAIL EDUCATOR READY™.',
  },
  {
    question: 'Ist das ein physisches Produkt?',
    answer: 'Nein. Du erhältst digitale Materialien zum Herunterladen, keine gedruckten Bücher.',
  },
  {
    question: 'Muss ich bereits Trainerin sein?',
    answer:
      'Nein. Die Sammlung eignet sich auch für erfahrene Nageldesignerinnen, die ihre ersten Schulungen vorbereiten möchten.',
  },
  {
    question: 'Erhalte ich damit eine staatlich anerkannte Trainerinnen-Zertifizierung?',
    answer:
      'Die Sammlung ist ein digitales Lern- und Unterrichtsmaterial. Sie stellt keine staatlich anerkannte Qualifikation dar.',
  },
  {
    question: 'Gibt es ein Abo oder monatliche Gebühren?',
    answer: 'Nein. Du zahlst einmalig und erhältst die komplette digitale Sammlung.',
  },
  {
    question: 'Ist die Zahlung sicher?',
    answer:
      'Ja. Die Zahlung ist sicher und verschlüsselt und wird automatisch in deiner Landeswährung abgewickelt.',
  },
]
